<style lang="scss">
.configs {
  .content-in-right {
    margin-left: 250px;
  }
  .menu-list-alignment {
    width: 262px;
  }
}
</style>

<template>
  <div class="configs">
    <v-container fluid>
      <v-navigation-drawer
        absolute
        v-model="drawer"
        :clipped="$vuetify.breakpoint.mdAndUpp"
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ __("Configurações", "settings") }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ __("Sistema", "settings") }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list dense class="menu-list-alignment">
          <v-list-group
            prepend-icon="mdi-folder"
            group="configs/attachments"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-title>{{
                __("Anexos", "schedulings")
              }}</v-list-item-title>
            </template>

            <v-list-item
              :to="{ name: 'attachment_upload_configs' }"
              color="primary"
              link
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ __("Upload", "settings") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'attachment_categories_configs' }"
              color="primary"
              link
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ __("Gestão de categorias", "settings") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'attachment_default_categories_configs' }"
              color="primary"
              link
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ __("Categorias padrões", "settings") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              no-action
              sub-group
              group="configs/attachments/insurer"
            >
              <template v-slot:activator>
                <v-list-item-content class="pl-2">
                  <v-list-item-title>{{
                    __("Companhia", "settings")
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                :to="{ name: 'attachment_insurer_restrictions_configs' }"
                color="primary"
                link
              >
                <v-list-item-title>
                  {{ __("Restrição de envio", "settings") }}
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                :to="{
                  name: 'attachment_insurer_available_categories_configs',
                }"
                color="primary"
                link
              >
                <v-list-item-title>
                  {{ __("Categorias disponíveis", "settings") }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group no-action sub-group group="configs/attachments/unity">
              <template v-slot:activator>
                <v-list-item-content class="pl-2">
                  <v-list-item-title>{{
                    __("Unidade", "settings")
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                :to="{ name: 'attachment_unity_available_categories_configs' }"
                color="primary"
                link
              >
                <v-list-item-title>
                  {{ __("Categorias disponíveis", "settings") }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list-group>

          <ScopeProvider scope="configs.eps.read">
            <v-list-group
              prepend-icon="mdi-server-network"
              no-action
              subgroup
              group="/configs/eps"
            >
              <template v-slot:activator>
                <v-list-item-title> EPS </v-list-item-title>
              </template>

              <v-list-item
                :to="{ name: 'eps_attachments_configs' }"
                color="primary"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ __("Adicionar anexo", "settings") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="{ name: 'eps_attachment_categories' }"
                color="primary"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ __("Categorias", "settings") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="{ name: 'eps_blocked_attachment_types' }"
                color="primary"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ __("Bloqueio - tipos de anexo", "settings") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </ScopeProvider>

          <ScopeProvider scope="configs.email.read">
            <v-list-group
              prepend-icon="mdi-email"
              no-action
              subgroup
              group="/configs/email"
            >
              <template v-slot:activator>
                <v-list-item-title> Email </v-list-item-title>
              </template>

              <v-list-item
                :to="{ name: 'emails_unities' }"
                color="primary"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ __("Unidades - Reply to", "settings") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </ScopeProvider>

          <v-list-group
            prepend-icon="mdi-briefcase"
            no-action
            group="/configs/leads/"
          >
            <template v-slot:activator>
              <v-list-item-title> Leads </v-list-item-title>
            </template>

            <v-list-item
              v-if="verifyScope('configs.leads.statuses.edit')"
              color="primary"
              link
              :to="{
                name: 'configs.leads.statuses',
              }"
            >
              <v-list-item-title>
                {{ __("Status", "settings") }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              color="primary"
              link
              :to="{
                name: 'leads_completed_statuses',
              }"
            >
              <v-list-item-title>
                {{ __("Status concluído", "settings") }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              color="primary"
              link
              :to="{
                name: 'leads_completed_without_value_statuses',
              }"
            >
              <v-list-item-title>
                {{ __("Concluído - sem orçamento", "settings") }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              color="primary"
              link
              :to="{
                name: 'leads_ignore_non_compliant_equipment',
              }"
            >
              <v-list-item-title>
                {{ __("Ignorar não enquadrado", "settings") }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              color="primary"
              link
              :to="{
                name: 'leads_active_statuses_unities',
              }"
            >
              <v-list-item-title>
                {{ __("Autonomia - unidades", "settings") }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              color="primary"
              link
              :to="{
                name: 'leads_statuses_automation',
              }"
            >
              <v-list-item-title>
                {{ __("status - automatização", "settings") }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              color="primary"
              link
              :to="{
                name: 'leads_block_statuses_automation',
              }"
            >
              <v-list-item-title>
                {{ __("bloqueio", "settings") }} -
                {{ __("automatização", "settings") }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              :to="{
                name: 'leads_requested_documents_types_by_lead_subtype',
              }"
              color="primary"
              link
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ __("Documentos solicitados", "settings") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <ScopeProvider scope="configs.distribution.read">
            <v-list-group
              prepend-icon="mdi-arrow-decision-auto"
              no-action
              subgroup
              group="/configs/leads_distribution"
            >
              <template v-slot:activator>
                <v-list-item-title>
                  {{ __("Distribuição de Leads", "settings") }}
                </v-list-item-title>
              </template>

              <v-list-item
                :to="{ name: 'leads_distribution_activate_deactivate' }"
                color="primary"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      __("Ativar", "settings") +
                      " / " +
                      __("Desativar", "settings")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                :to="{ name: 'unities_availability_score' }"
                color="primary"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ __("Score Unidades", "settings") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </ScopeProvider>

          <ScopeProvider scope="configs.products.read">
            <v-list-group
              prepend-icon="mdi-devices"
              no-action
              subgroup
              group="/configs/equipaments"
            >
              <template v-slot:activator>
                <v-list-item-title>
                  {{ __("equipamentos", "settings") }}
                </v-list-item-title>
              </template>

              <v-list-item
                :to="{ name: 'config_equipament_types' }"
                color="primary"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ __("tipos de equipamento", "settings") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </ScopeProvider>

          <ScopeProvider scope="configs.addresses.postal_codes.read">
            <v-list-group
              prepend-icon="mdi-map-marker-radius"
              no-action
              subgroup
              group="/configs/addresses/postal_codes"
            >
              <template v-slot:activator>
                <v-list-item-title>
                  {{ __("endereços", "settings") }}
                </v-list-item-title>
              </template>

              <v-list-item
                :to="{ name: 'config_addresses_postal_codes' }"
                color="primary"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ __("códigos postais", "settings") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </ScopeProvider>

          <v-list-item
            v-if="verifyScope('configs.insurers_portal.theme.edit')"
            :to="{ name: 'configs.insurers_portal' }"
            color="primary"
            link
          >
            <v-list-item-icon>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ __("portal das companhias", "settings") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            prepend-icon="mdi-form-dropdown"
            no-action
            subgroup
            group="/configs/forms"
          >
            <template v-slot:activator>
              <v-list-item-title>
                {{ __("Formulários", "settings") }}
              </v-list-item-title>
            </template>

            <v-list-item
              :to="{ name: 'form-options-categories' }"
              color="primary"
              link
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ __("Opções e valores", "settings") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'configs-forms-templates' }"
              color="primary"
              link
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ __("Templates", "settings") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            :to="{ name: 'configs.feature-flags' }"
            exact
            color="primary"
            link
          >
            <v-list-item-icon>
              <v-icon>mdi-toggle-switch</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ __("Funcionalidades", "feature_flags") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="isMaster()" color="primary" link @click="openPulse">
            <v-list-item-icon>
              <v-icon>mdi-chart-line</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ __("Monitoramento", "settings") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            prepend-icon="mdi-signature-text"
            no-action
            subgroup
            group="/configs/text-templates"
          >
            <template v-slot:activator>
              <v-list-item-title>
                {{ __("Textos customizáveis", "text_templates") }}
              </v-list-item-title>
            </template>

            <v-list-item
              :to="{ name: 'configs.text-templates' }"
              color="primary"
              link
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ __("Relatório Riscos Elétricos", "text_templates") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>
      <div :class="{ 'content-in-right': drawer }">
        <div v-if="!drawer">
          <v-btn @click="drawer = !drawer" icon>
            <v-icon>mdi-arrow-expand-right</v-icon>
          </v-btn>
        </div>
        <router-view></router-view>
      </div>
    </v-container>
  </div>
</template>

<script>
import ScopeProvider from "@/components/ScopeProvider";
import i18n from "@/mixins/i18n";
import ScopesMixin from "../mixins/ScopesMixin.vue";
import { link as pulseLink } from "@/services/system/pulse";

export default {
  components: {
    ScopeProvider,
  },
  mixins: [i18n, ScopesMixin],
  data() {
    return {
      drawer: null,
      admins: [
        ["Management", "mdi-account-multiple-outline"],
        ["Settings", "mdi-cog-outline"],
      ],
      cruds: [
        ["Create", "mdi-plus-outline"],
        ["Read", "mdi-file-outline"],
        ["Update", "mdi-update"],
        ["Delete", "mdi-delete"],
      ],
    };
  },
  methods: {
    async openPulse() {
      // A aba abre antes do await: depois dele o navegador bloqueia como pop-up
      const tab = window.open("", "_blank");

      try {
        const { url } = await pulseLink();
        // Caminho relativo: em produção o Laravel serve o SPA, mesma origem. No dev
        // o vue-cli serve o index.html em navegações, então vai direto ao backend
        tab.location = new URL(url, process.env.VUE_APP_BACKEND_URL || window.location.origin).href;
      } catch (e) {
        tab.close();
        this.$store.commit("sendMessage", {
          text: this.__("Não foi possível abrir o monitoramento", "settings"),
          color: "red",
        });
      }
    },
  },
};
</script>
